import { Environment } from './environment.model';
import 'angular-server-side-configuration/process';

export const ENVIRONMENT: Environment = {
  production: false,
  stage: process.env.ENVIRONMENT_LABEL,
  baseUrl: process.env.BASE_URL,
  reportsBaseUrl: process.env.reportsBaseUrl,
  dmsBaseUrl: process.env.DMS_BASE_URL,
  pwaEnabled: true,

  arcgisOauthConfig: {
    clientId: process.env.CLIENT_ID,
    portalUrl: process.env.PORTAL_URL,
  },
  googleMapsConfig: {
    apiKey: process.env.GOOGLE_MAPS_API_KEY,
    geometryServiceUrl:process.env.GOOGLE_MAP_GEOMETRY_SERVICE_URL,
    streetViewRadius: 200
  },
  sbbInfoBannerConfig: {
    application: 'IMMO',
    serviceUrl: process.env.BASE_URL +
      '/site/rest/services/IVEG_PUBLIC/iveg_config_public/FeatureServer/111',
    checkForMessageTimeout: 5,
  },
};
